
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'

import NcButton from '@nextcloud/vue/dist/Components/NcButton.js'
import NcNoteCard from '@nextcloud/vue/dist/Components/NcNoteCard.js'

import AvatarWrapper from '../AvatarWrapper/AvatarWrapper.vue'

import { AVATAR } from '../../constants.js'

export default {
	name: 'NewMessageAbsenceInfo',

	components: {
		AvatarWrapper,
		ChevronUp,
		NcButton,
		NcNoteCard,
	},

	props: {
		userAbsence: {
			type: Object,
			required: true,
		},

		displayName: {
			type: String,
			required: true,
		},
	},

	setup() {
		return { AVATAR }
	},

	data() {
		return {
			collapsed: true,
			isTextMoreThanOneLine: false,
		}
	},

	computed: {
		token() {
			return this.$store.getters.getToken()
		},

		userAbsenceCaption() {
			return t('spreed', '{user} is out of office and might not respond.', { user: this.displayName })
		},

		userAbsenceMessage() {
			return this.userAbsence.message || this.userAbsence.shortMessage
		},
	},

	watch: {
		userAbsenceMessage() {
			this.$nextTick(() => {
				this.setIsTextMoreThanOneLine()
			})
		},
	},

	mounted() {
		this.setIsTextMoreThanOneLine()
	},

	methods: {
		toggleCollapsed() {
			this.collapsed = !this.collapsed
		},

		setIsTextMoreThanOneLine() {
			this.isTextMoreThanOneLine = this.$refs.absenceMessage?.scrollHeight > this.$refs.absenceMessage?.clientHeight
		},
	},
}
